// Angular
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-general-action-dialog',
  templateUrl: './general-action-dialog.component.html',
  styleUrls: ['./general-action-dialog.component.scss'],
})
export class GeneralActionDialogComponent {
  // Public properties
  viewLoading = false;

  /**
   * Component constructor
   *
   * @param dialogRef
   * @param data
   */
  constructor(
    public dialogRef: MatDialogRef<GeneralActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      description: string;
      waitDescription: string;
      confirmText: string;
      cancelText: string;
      showConfirm: boolean;
      showCancel: boolean;
    },
  ) {}

  /**
   * Close dialog with false result
   */
  cancel(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  /**
   * Close dialog with true result
   */
  confirm(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close(true);
  }
}
